import React, { useMemo, useState } from "react";
import { Modal, Radio, Table } from "antd";
import { useTranslation } from "react-i18next";
import { CompanyUserListingColumns } from "./WtcListingColumns";
import { useMediaQuery } from "@mui/material";
import Search from "antd/es/input/Search";
import { WTCPrintable } from "../../../Printables/WTCPrintable";

import { useWtcData } from "../../../../Hooks/useWtcData";

function WtcListingContent() {
  const { t } = useTranslation();
  const { wtc, mutate, isLoading } = useWtcData();
  const [selectedWtc, setSelectedWtc] = useState(null);
  const [search, setSearch] = useState("");
  const [searchStatus, setSearchStatus] = useState<"ALL" | "pp" | "pm">("ALL");

  const dataToDisplay = useMemo(() => {
    let filterWtcs = wtc || [];

    if (searchStatus === "ALL") {
      filterWtcs = wtc;
    }

    if (searchStatus === "pp") {
      filterWtcs = filterWtcs.filter((certif: any) => {
        return Boolean(certif.beneficiaryType === "PP");
      });
    }
    if (searchStatus === "pm") {
      filterWtcs = filterWtcs.filter((certif: any) => {
        return Boolean(certif.beneficiaryType === "PM");
      });
    }

    return search
      ? filterWtcs.filter((certif: any) => {
          return Boolean(
            certif.beneficiaryName
              ?.toLowerCase()
              .includes(search.toLowerCase()) ||
              certif.beneficiaryIdentifier
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
              certif.withholdingObject
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
              certif.withholdingTaxCertificate
                ?.toLowerCase()
                .includes(search.toLowerCase()),
          );
        })
      : filterWtcs;
  }, [wtc, search, searchStatus]);

  const showCertificate = (withholdingTaxCertificate: string) => {
    setSelectedWtc(
      wtc.filter(
        (certificate: any) =>
          certificate.withholdingTaxCertificate === withholdingTaxCertificate,
      )[0],
    );
  };

  const handleCloseModal = () => {
    setSelectedWtc(null);
  };
  const columns = CompanyUserListingColumns(t, showCertificate);
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");

  return (
    <div className="w-full  overflow-scroll p-10">
      {selectedWtc ? (
        <Modal
          open={selectedWtc}
          width={isSmallDevice ? "100% " : "80%"}
          onCancel={() => handleCloseModal()}
          footer={null}
        >
          <WTCPrintable wtc={selectedWtc} mutate={mutate} />
        </Modal>
      ) : null}
      <div className="flex gap-4 mb-4 justify-between flex-col md:flex-row min-w-fit">
        <div className="flex gap-4">
          <Search
            placeholder={t("search")}
            allowClear
            loading={isLoading}
            onSearch={(value) => {
              setSearch(value);
            }}
            style={{ width: 304 }}
          />
        </div>
        <Radio.Group
          value={searchStatus}
          disabled={isLoading}
          onChange={(e) => setSearchStatus(e.target.value)}
        >
          <Radio.Button value="ALL">{t("ALL")}</Radio.Button>
          <Radio.Button value="pp">{t("PP")}</Radio.Button>
          <Radio.Button value="pm">{t("PM")}</Radio.Button>
        </Radio.Group>
      </div>

      <Table
        rowKey="withholdingTaxCertificate"
        size="small"
        loading={isLoading}
        dataSource={(dataToDisplay && dataToDisplay) || []}
        columns={columns}
        rootClassName="h-2/3 min-h-2/3 "
        bordered={true}
      />
    </div>
  );
}

export default WtcListingContent;
